module.exports = __webpack_public_path__ + "img/14.95ee4a33.png";